import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, catchError, map, throwError } from 'rxjs';
import { AuthDataService } from '../services/auth-data.service';
import { ENVIRONMENT } from 'src/environments/environment';

@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {

  constructor(
    private authDataService: AuthDataService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request)
      .pipe(
        map(response => { return response }),
        catchError((error: HttpErrorResponse) => {
          return this.errorHandler(error);
        })
      );
  }

  errorHandler(error: HttpErrorResponse):Observable<never> {
    if (error.status === 401 && error.url !== ENVIRONMENT.urls.fastData.api) this.authErrorHandler(error);
    return throwError(() => {
      return {
        status: error.status,
        message: `Error: ${error.message}`
      }
    });
  }

  authErrorHandler(error: HttpErrorResponse): void{
    this.authDataService.logout();
  }
}
